/* eslint-disable max-len */
import headerActionsStyle from '../../material-dashboard-pro-react/assets/jss/material-dashboard-pro-react/components/headerActionsStyle';

import {
  defaultFont,
  primaryColor,
  secondaryColor,
  vertMd,
} from '../../styles/style';

const style = (theme) => ({
  ...headerActionsStyle(theme),
  popper_responsive: {
    [theme.breakpoints.down('sm')]: {
      position: 'static',
      float: 'none',
      width: 'auto',
      marginTop: '0',
      backgroundColor: 'transparent',
      border: '0',
      boxShadow: 'none',
      color: 'black',
      zIndex: 5,
    },
  },
  popper_close: {
    pointerEvents: 'none',
  },

  link__text: {
    zIndex: '4',
    ...defaultFont,
    fontSize: '14px',
    margin: '0!important',
  },
  icon: {
    width: '26px',
    height: '26px',
    zIndex: '4',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      width: '30px',
      height: '30px',
      color: 'inherit',
      opacity: '0.8',
      marginRight: '16px',
      marginLeft: '-5px',
    },
  },
  button: {
    'borderRadius': '3px',
    'margin': '0 10px 4px',
    'padding': '2px 4px',
    'width': '90px',
    [`${theme.breakpoints.down('sm')}, (max-height: ${vertMd})`]: {
      display: 'flex',
      justifyContent: 'flex-start',
      width: '100%',
      height: '50px',
      margin: '0',
      padding: '0 20px',
    },
    [`${theme.breakpoints.up('md')} and (max-height: ${vertMd})`]: {
      padding: '0 8px',
    },
    '&:hover': {
      outline: 'none',
      backgroundColor: 'rgba(200, 200, 200, 0.2)',
      boxShadow: 'none',
    },
  },
  button__text: {
    ...defaultFont,
    color: 'inherit',
    fontSize: '13px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [`${theme.breakpoints.down('sm')}, (max-height: ${vertMd})`]: {
      flexDirection: 'row',
    },
  },

  dropdown: {
    maxWidth: '300px',
  },
  dropdown__header_profile: {
    ...defaultFont,
    fontWeight: '400',
    fontSize: '13px',
    color: '#FFF',
    padding: '10px 20px',
    textAlign: 'center',
    backgroundColor: secondaryColor,
  },
  dropdown__header_accountSwitcher: {
  },
  dropdown__header_organizationSwitcher: {
  },
  dropdown__header_accountName: {
    width: '65%',
    marginRight: '10px',
  },
  dropdown__item: {
    ...defaultFont,
    'display': 'flex',
    'justifyContent': 'flex-start',
    'alignItems': 'center',
    'fontSize': '13px',
    'padding': '10px 20px',
    'borderRadius': '2px',
    'position': 'relative',
    'transition': 'all 150ms linear',
    'clear': 'both',
    'fontWeight': '400',
    'height': 'fit-content',
    'color': '#333',
    'whiteSpace': 'nowrap',
    '&:hover': {
      backgroundColor: primaryColor,
      color: '#FFFFFF',
    },
  },
  dropdown__item_email: {
    'backgroundColor': secondaryColor,
    'color': '#FFF',
    'display': 'inherit',
    'textAlign': 'center',
    '&:hover': {
      backgroundColor: secondaryColor,
      color: '#FFF',
    },
  },
  dropdown__item_header: {
    'backgroundColor': secondaryColor,
    'color': '#FFF',
    'display': 'inherit',
    'textAlign': 'center',
    '&:hover': {
      backgroundColor: secondaryColor,
      color: '#FFF',
    },
  },
  dropdownItem__icon: {
    marginRight: '5px',
    width: '25px',
    height: '25px',
  },
  dropdown__item_filterAccounts: {
    '&:hover': {
      backgroundColor: '#FFF',
    },
  },
  dropdown_item_loggedInAccount: {
    backgroundColor: secondaryColor,
    color: '#FFF',
    pointerEvents: 'none',
  },
  dropdownItem__accountName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginRight: '10px',
  },
  dropdown__item_filterOrganizations: {
    '&:hover': {
      backgroundColor: '#FFF',
    },
  },
  dropdown_item_currentOrganization: {
    backgroundColor: secondaryColor,
    color: '#FFF',
    pointerEvents: 'none',
  },
  dropdownItem__organizationName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginRight: '10px',
  },

  action__menuList: {
    padding: 0,
    maxHeight: '500px',
    overflowY: 'auto',
  },
  action__menuList_hamburger: {
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
  },
});

export default style;
